import { Action } from '@ngrx/store';
import { MMDReads } from '../../models/mmd-read';
import { PayloadAction } from '@ipreo/muni-shared';

const MMD_LOAD_REQUESTED = '[marketDrawer] Fetch MMDReads';
const MMD_LOAD_SUCCESS = '[marketDrawer] Fetch MMDReads Success';
const MMD_LOAD_FAILURE = '[marketDrawer] Fetch MMDReads Error';
const MMD_SEEN = '[marketDrawer] See MMDReads';

/* tslint:disable:max-classes-per-file */
class MMDReadsLoadAction implements Action {
  public readonly type = MMD_LOAD_REQUESTED;
}

class MMDLoadSuccessAction implements PayloadAction<MMDReads> {
  public readonly type = MMD_LOAD_SUCCESS;

  constructor(public payload: MMDReads) {}
}

class MMDLoadErrorAction implements PayloadAction<string> {
  public readonly type = MMD_LOAD_FAILURE;

  constructor(public payload: string) {}
}

class SeeReadsAction implements Action {
  public readonly type = MMD_SEEN;
}

export {
  Action,
  MMDReadsLoadAction,
  MMDLoadSuccessAction,
  MMDLoadErrorAction,
  SeeReadsAction,
  MMD_LOAD_REQUESTED,
  MMD_LOAD_SUCCESS,
  MMD_LOAD_FAILURE,
  MMD_SEEN
};
